export { default } from "./profile.png";
